{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} conversations selected",
    "AGENT_SELECT_LABEL": "Select agent",
    "ASSIGN_CONFIRMATION_LABEL": "Are you sure to assign {conversationCount} {conversationLabel} to",
    "UNASSIGN_CONFIRMATION_LABEL": "Are you sure to unassign {conversationCount} {conversationLabel}?",
    "GO_BACK_LABEL": "Mene takaisin",
    "ASSIGN_LABEL": "Delegoi",
    "YES": "Yes",
    "SEARCH_INPUT_PLACEHOLDER": "Etsi",
    "ASSIGN_AGENT_TOOLTIP": "Assign agent",
    "ASSIGN_TEAM_TOOLTIP": "Assign team",
    "ASSIGN_SUCCESFUL": "Conversations assigned successfully.",
    "ASSIGN_FAILED": "Failed to assign conversations. Please try again.",
    "RESOLVE_SUCCESFUL": "Conversations resolved successfully.",
    "RESOLVE_FAILED": "Failed to resolve conversations. Please try again.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Conversations visible on this page are only selected.",
    "AGENT_LIST_LOADING": "Loading agents",
    "UPDATE": {
      "CHANGE_STATUS": "Change status",
      "SNOOZE_UNTIL": "Snooze",
      "UPDATE_SUCCESFUL": "Conversation status updated successfully.",
      "UPDATE_FAILED": "Failed to update conversations. Please try again."
    },
    "LABELS": {
      "ASSIGN_LABELS": "Assign labels",
      "NO_LABELS_FOUND": "No labels found for",
      "ASSIGN_SELECTED_LABELS": "Assign selected labels",
      "ASSIGN_SUCCESFUL": "Labels assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign labels. Please try again."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "Select team",
      "NONE": "None",
      "NO_TEAMS_AVAILABLE": "There are no teams added to this account yet.",
      "ASSIGN_SELECTED_TEAMS": "Assign selected team.",
      "ASSIGN_SUCCESFUL": "Teams assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign team. Please try again."
    },
    "MERGE": {
      "TOOLTIP": "Yhdistä keskustelut",
      "TITLE": "Yhdistä keskustelut",
      "DESCRIPTION": "Valitse kohdekeskustelu. Kaikki muut valitut keskustelut yhdistetään siihen – niiden viestit siirretään kohteeseen ja lähdekeskustelut poistetaan.",
      "TARGET_LABEL": "Kohdekeskustelu (säilytetään)",
      "SOURCES_LABEL": "Lähdekeskustelut (poistetaan)",
      "SELECT_TARGET": "Valitse keskustelu yhdistämisen kohteeksi",
      "WARNING": "Varoitus: Tätä toimintoa ei voi perua. Kaikkien lähdekeskustelujen viestit siirretään kohdekeskusteluun, ja lähdekeskustelut poistetaan pysyvästi.",
      "SUBMIT": "Yhdistä keskustelut",
      "CANCEL": "Peruuta",
      "SUCCESS_MESSAGE": "Keskustelut yhdistettiin onnistuneesti",
      "ERROR_MESSAGE": "Keskusteluja ei voitu yhdistää. Yritä uudelleen.",
      "CONFIRM": {
        "TITLE": "Vahvista yhdistäminen",
        "DESCRIPTION": "Haluatko varmasti yhdistää {sourceCount} keskustelua kohteeseen #{targetId}? Tätä toimintoa ei voi perua.",
        "YES": "Kyllä, yhdistä",
        "CANCEL": "Peruuta"
      }
    }
  }
}
